/* Kuba PDP · grupo "galeria"
   - lightbox da galeria editorial (kuba-galeria, layout editorial): [data-kb-lb-open] + <script data-kb-lb-data>
   - modal de vídeo YouTube (kuba-experts): [data-kb-video] → .kb-video (CSS em kuba-ext.css)
   Idempotente: guarda global + re-init em shopify:section:load. */
(function () {
  if (window.__kbGaleriaLoaded) { window.__kbGaleriaInit && window.__kbGaleriaInit(); return; }
  window.__kbGaleriaLoaded = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sectionVars(sec) {
    var st = sec ? getComputedStyle(sec) : null;
    return {
      bg: st ? st.getPropertyValue('--bg').trim() : '',
      acc: st ? (st.getPropertyValue('--acc-soft').trim() || st.getPropertyValue('--acc').trim()) : ''
    };
  }

  /* ---------- lightbox ---------- */
  var lb = null, lbIdx = 0, lbItems = [], lbTouchX = null;

  function lbClose() {
    if (!lb) return;
    lb.remove(); lb = null;
    document.body.classList.remove('kb-lb-open');
    document.removeEventListener('keydown', lbKey);
  }
  function lbGo(i) {
    var n = lbItems.length; if (!n) return;
    lbIdx = ((i % n) + n) % n;
    lb.querySelector('.kb-lb__track').style.transform = 'translateX(-' + (lbIdx * 100) + '%)';
    lb.querySelector('.kb-lb__count').textContent = pad(lbIdx + 1) + ' / ' + pad(n);
    var cap = lbItems[lbIdx].cap || '';
    lb.querySelector('.kb-lb__cap').textContent = cap ? pad(lbIdx + 1) + ' · ' + cap : pad(lbIdx + 1);
  }
  function lbKey(e) {
    if (e.key === 'Escape') lbClose();
    else if (e.key === 'ArrowRight') lbGo(lbIdx + 1);
    else if (e.key === 'ArrowLeft') lbGo(lbIdx - 1);
  }
  function lbOpen(items, vars, start) {
    lbClose();
    lbItems = items || [];
    if (!lbItems.length) return;
    lb = document.createElement('div');
    lb.className = 'kb-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Galeria de fotos');
    if (vars.bg) lb.style.setProperty('--kb-lb-bg', vars.bg);
    if (vars.acc) lb.style.setProperty('--kb-lb-acc', vars.acc);
    var slides = lbItems.map(function (it, i) {
      var inner = it.src
        ? '<img src="' + esc(it.src) + '"' + (it.srcset ? ' srcset="' + esc(it.srcset) + '" sizes="100vw"' : '') + ' alt="' + esc(it.cap) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">'
        : '<div class="kb-lb__ph"><span>' + esc(it.ph || 'FOTO') + '</span></div>';
      return '<div class="kb-lb__slide"><div class="kb-lb__img">' + inner + '</div></div>';
    }).join('');
    lb.innerHTML =
      '<div class="kb-lb__top"><span class="kb-lb__count"></span><button type="button" class="kb-lb__close" aria-label="Fechar">✕</button></div>' +
      '<div class="kb-lb__stage"><div class="kb-lb__track">' + slides + '</div></div>' +
      '<div class="kb-lb__foot"><p class="kb-lb__cap"></p><div class="kb-lb__nav">' +
      '<button type="button" class="kb-lb__prev" aria-label="Foto anterior">←</button>' +
      '<button type="button" class="kb-lb__next" aria-label="Próxima foto">→</button></div></div>';
    lb.querySelector('.kb-lb__close').addEventListener('click', lbClose);
    lb.querySelector('.kb-lb__prev').addEventListener('click', function () { lbGo(lbIdx - 1); });
    lb.querySelector('.kb-lb__next').addEventListener('click', function () { lbGo(lbIdx + 1); });
    var stage = lb.querySelector('.kb-lb__stage');
    stage.addEventListener('touchstart', function (e) { lbTouchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (lbTouchX == null) return;
      var dx = e.changedTouches[0].clientX - lbTouchX; lbTouchX = null;
      if (Math.abs(dx) > 40) lbGo(lbIdx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.body.appendChild(lb);
    document.body.classList.add('kb-lb-open');
    document.addEventListener('keydown', lbKey);
    lbGo(start || 0);
    var c = lb.querySelector('.kb-lb__close'); c && c.focus();
  }
  function gallery() {
    document.querySelectorAll('.kb-gal[data-kb-gal="editorial"]').forEach(function (sec) {
      if (sec.__kbLb) return;
      sec.__kbLb = true;
      var data = sec.querySelector('[data-kb-lb-data]');
      var items = [];
      try { items = JSON.parse(data ? data.textContent : '[]') || []; } catch (e) { items = []; }
      sec.querySelectorAll('[data-kb-lb-open]').forEach(function (b) {
        b.addEventListener('click', function () { lbOpen(items, sectionVars(sec), 0); });
      });
      // desktop: clicar numa figura também abre o lightbox naquela foto
      sec.querySelectorAll('.kb-gal__fig .kb-gal__item-img, .kb-gal__wide').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-kb-lb-index') || '-1', 10);
        if (i < 0) return;
        el.style.cursor = 'zoom-in';
        el.addEventListener('click', function () { lbOpen(items, sectionVars(sec), i); });
      });
    });
  }

  /* ---------- modal de vídeo (YouTube) ---------- */
  function closeVideo() {
    var m = document.querySelector('.kb-video');
    if (m) m.remove();
    document.removeEventListener('keydown', onVideoKey);
  }
  function onVideoKey(e) { if (e.key === 'Escape') closeVideo(); }
  function openVideo(id, title) {
    closeVideo();
    id = (id || '').trim();
    var m = document.createElement('div');
    m.className = 'kb-video';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    var inner = id
      ? '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="' + esc(title) + '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>'
      : '<div class="kb-video__empty">Adicione o ID do vídeo do YouTube no bloco desta seção (campo "ID do vídeo no YouTube") para reproduzir aqui.</div>';
    m.innerHTML = '<div class="kb-video__box"><button type="button" class="kb-video__close" aria-label="Fechar">×</button>' + inner + '</div>';
    m.addEventListener('click', function (e) { if (e.target === m || e.target.classList.contains('kb-video__close')) closeVideo(); });
    document.body.appendChild(m);
    document.addEventListener('keydown', onVideoKey);
  }
  function video() {
    document.querySelectorAll('[data-kb-video]').forEach(function (b) {
      if (b.__kbVideo) return;
      b.__kbVideo = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openVideo(b.getAttribute('data-kb-video'), b.getAttribute('data-kb-video-title'));
      });
    });
  }

  function init() { gallery(); video(); }
  window.__kbGaleriaInit = init;
  window.__kbOpenVideo = openVideo;
  window.__kbOpenLightbox = lbOpen;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:unload', function () { lbClose(); closeVideo(); });
})();
